'use strict';
const angular = require('angular');

export default angular.module('wftOrderFormApp.repeatEndWatch', [])
  .directive('repeatEndWatch', function() {
    return {
      restrict: 'A',
      scope: {},
      link: function(scope, element, attrs) {
        if(attrs.ngRepeat) {
          if(scope.$parent.$last) {
            if(attrs.repeatEndWatch !== '') {
            	scope.$parent.$eval(attrs.repeatEndWatch);
            }
          }
        } else {
            throw 'repeatEndWatch: `ngRepeat` Directive required to use this Directive';
        }
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directives/repeatEndWatch/repeatEndWatch.directive.js